import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { GlobalConstants } from "src/app/pages/common/global-variables";
import { ApiService } from "../pages/common/api.service";
import { ILanguage } from "../shared/components/header/header.component";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    public GlobalConstants: GlobalConstants,
    public _apiService: ApiService,
    @Inject(LOCALE_ID) public locale: string,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!sessionStorage.getItem("userLanguage") || ((sessionStorage.getItem("userLanguage")) && JSON.parse(sessionStorage.getItem("userLanguage"))?.attributes?.iso639_1 !== this.locale)) {
      return this._apiService
        .getAllLanguages()
        .toPromise()
        .then((res: { data: ILanguage[] }) => {
          let selectedLanguage = res?.data.find(
            (language: ILanguage) => language?.attributes?.iso639_1 === this.locale
          );
          if (selectedLanguage) {
            sessionStorage.setItem(
              "userLanguage",
              JSON.stringify(selectedLanguage)
            );
            return this.checkAuthGuard();
          }
        })
        .catch((err) => {
          console.log("error while fetching languages", err);
          return this.checkAuthGuard()
        });
    } else {
      return this.checkAuthGuard();
    }
  }

  public checkAuthGuard() {
    if (!this.GlobalConstants.data.homepage_needed) {
      this.router.navigate([
        "offer/offer-details/8dcd7fd5-d560-45c9-96e2-69d4568697f9/all/dropbox",
      ]);
      return false;
    }
    return true;
  }
}
